import { contains, curry } from "ramda";
import { createSelector } from "reselect";
import { State } from "../../../state";

export const getHighlightedRows = (state: State) => state.highlightedRows;

const isRowHighlightedHelper = curry(
  (highlightedRows: string[], accountId: string): boolean =>
    contains(accountId, highlightedRows)
);

export const getIsRowHighlighted = createSelector(
  getHighlightedRows,
  highlightedRows => isRowHighlightedHelper(highlightedRows)
);



// WEBPACK FOOTER //
// ./src/spread/model/highlightedRows/selector.ts